import { all, takeLatest, select } from 'redux-saga/effects';
import { BookingTypes } from './BookingRedux';

import {
  trackPMResidentSelected,
  trackBuildingAdded,
  trackOnetimeLvlSel,
  trackServiceFreqSel,
  trackOnetimeAddSrvcs,
  trackOnetimeSrvcDateSel,
  trackRecurOptSel,
  trackRecurAddSrvcs,
  trackRecurStartDateSel,
  fmtUserInfo
} from '@services/analytics';
import { BOOKING_STAGE, FREQUENCIES } from '@services/minte';

import logger from '@utils/logger';

export function* watchBookingAnalytics() {
  const state = yield select();
  try {
    const userInfo = yield fmtUserInfo(state);
    if (state.booking.prevStep === BOOKING_STAGE.RECIPIENT) {
      if (state.booking.isPMBooking) {
        trackPMResidentSelected(userInfo, state);
      } else {
        trackBuildingAdded(userInfo, state);
      }
    } else if (
      state.booking.prevStep === BOOKING_STAGE.FREQUENCY &&
      state.booking.step !== BOOKING_STAGE.FREQUENCY &&
      state.booking.step !== BOOKING_STAGE.RECIPIENT
    ) {
      trackServiceFreqSel(userInfo, state);
    } else {
      switch (state.booking.frequency) {
        case FREQUENCIES.ONCE:
          switch (state.booking.prevStep) {
            case BOOKING_STAGE.SERVICE_TYPE:
              trackOnetimeLvlSel(userInfo, state);
              break;
            case BOOKING_STAGE.ADDON:
              trackOnetimeAddSrvcs(userInfo, state);
              break;
            case BOOKING_STAGE.SERVICE_DATE:
              trackOnetimeSrvcDateSel(userInfo, state);
              break;
          }
          break;
        case FREQUENCIES.REGULARLY:
          switch (state.booking.prevStep) {
            case BOOKING_STAGE.SERVICE_TYPE:
              trackRecurOptSel(userInfo, state);
              break;
            case BOOKING_STAGE.ADDON:
              trackRecurAddSrvcs(userInfo, state);
              break;
            case BOOKING_STAGE.SERVICE_DATE:
              trackRecurStartDateSel(userInfo, state);
              break;
          }
      }
    }
  } catch (err) {
    logger.log('anaytics', err);
  }

  yield undefined;
}

export default function* root() {
  yield all([takeLatest(BookingTypes.SET_BOOKING_STEP, watchBookingAnalytics)]);
}
